import {Min, ValidationOptions} from 'class-validator';

export function MyMin(minNumber: number, validationOptions: ValidationOptions = {}) {
  const options = Object.assign({message: `Ensure this value is greater than or equal to ${minNumber}`}, validationOptions);
  return Min(minNumber, options);
}
